module.exports = __webpack_public_path__ + "static/media/van.ede07406.webp";